<template>
    <div>
        <transition name="fab-menu" mode="out-in">
            <Fab type="button" :key="'fabOpen'" v-if="!openMenu" icon="cog" color="green" :custom-style="{bottom: bottomPixels}" @click="$emit('onExpand', true)"/>
            <Fab type="button" :key="'fabClose'" v-else icon="times" color="dark" :custom-style="{bottom: bottomPixels}" @click="$emit('onExpand', true)"/>
        </transition>

        <Fab type="button" icon="filter" size="mini" v-if="openMenu" :custom-style="{bottom: calculatePixels(70)}" color="red" @click="$emit('onFilter', true)"/>
        <Fab type="link" :to="urlNew" icon="plus" size="mini" v-if="openMenu" :custom-style="{bottom: calculatePixels(130)}" color="blue"/>
    </div>
</template>

<script>
    import Fab from "./Fab";

    export default {
        name: "FabMenuCrud",
        components: {
            Fab,
        },
        props: {
            urlNew: {
                type: String,
                required: true
            },
            isOpen: {
                type: Boolean,
                default: false,
            },
            bottomPixels: {
                type: String,
                default: '80px',
                validator: val => /\d+px$/.test(val)
            }
        },
        methods: {
            calculatePixels(pixels) {
                const base = parseInt(this.bottomPixels.replace(/\D+/, ''));

                return `${pixels + base}px`
            }
        },
        computed: {
            openMenu() {
                return this.isOpen
            }
        }
    }
</script>

<style scoped>

</style>
